import * as React from 'react'

import { ProductBlock as GravityProductBlock } from '@thg-commerce/gravity-patterns'
import { ProductBlockProps as GravityProductBlockProps } from '@thg-commerce/gravity-patterns/ProductBlock/ProductBlock'
import { ProductPriceData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPrice'

import { useQuickBuyClickHandler } from './hooks'
import { ProductPriceProps } from '@thg-commerce/gravity-elements'
import { useSiteConfig } from '@thg-commerce/enterprise-core'

export type ProductBlockProps = GravityProductBlockProps &
  ProductPrice & {
    sku: string
    button?: Omit<GravityProductBlockProps['button'], 'onClick'> & {
      quickBuyTitle: string
    }
    fetchPrice?: boolean
    fromRecommendations?: boolean
    onQuickBuyClickEventEmitter?: () => void
    quickBuyFeatureEnabled?: boolean
  }

interface ProductPrice {
  productPrice?: ProductPriceData
  price?: ProductPriceProps
}

export const ProductBlock = (props: ProductBlockProps) => {
  return <EnterpriseProductBlock {...props} />
}

const EnterpriseProductBlock = React.memo((props: ProductBlockProps) => {
  const { quickBuyTitle: quickBuyButtonTitle } = {
    ...props.button,
  }
  const quickBuyClickHandler = useQuickBuyClickHandler(
    props.sku,
    props.fromRecommendations,
  )

  const {
    showProductBlockBrandTitle,
    hideProductListSwatch,
    previewQuickbuy,
  } = useSiteConfig()

  const onQuickBuyClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.stopPropagation()
    quickBuyClickHandler(event)
    props.onQuickBuyClickEventEmitter?.()
  }

  return (
    <GravityProductBlock
      {...props}
      image={{ ...props.image, lazy: true }}
      showBrandTitle={showProductBlockBrandTitle}
      hideProductListSwatch={hideProductListSwatch}
      button={
        props.button && {
          ...props.button,
          title:
            previewQuickbuy && quickBuyButtonTitle
              ? quickBuyButtonTitle
              : props.button.title,
          onClick: previewQuickbuy ? onQuickBuyClick : undefined,
        }
      }
    />
  )
})
